/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface PublishApplication200ResponseData
 */
export interface PublishApplication200ResponseData {
  /**
   * Порядковый номер заявки
   * @type {number}
   * @memberof PublishApplication200ResponseData
   */
  applicationId: number
}

/**
 * Check if a given object implements the PublishApplication200ResponseData interface.
 */
export function instanceOfPublishApplication200ResponseData(
  value: object
): value is PublishApplication200ResponseData {
  if (!('applicationId' in value) || value['applicationId'] === undefined)
    return false
  return true
}

export function PublishApplication200ResponseDataFromJSON(
  json: any
): PublishApplication200ResponseData {
  return PublishApplication200ResponseDataFromJSONTyped(json, false)
}

export function PublishApplication200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PublishApplication200ResponseData {
  if (json == null) {
    return json
  }
  return {
    applicationId: json['applicationId'],
  }
}

export function PublishApplication200ResponseDataToJSON(
  value?: PublishApplication200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    applicationId: value['applicationId'],
  }
}
